import axios from "axios";
import { refreshSession, isRefreshInFlight } from "./session";
const apiKey = process.env.REACT_APP_API_KEY;
const baseURL = process.env.REACT_APP_BACKEND_URL || '';

axios.defaults.baseURL = baseURL;


// Request interceptor - добавляет токен в заголовки
axios.interceptors.request.use(
    function (config: any) {
      // Пропускаем запросы на refreshToken без добавления токена, чтобы избежать рекурсии
      if (config.url?.includes('/auth/refreshToken') || config.skipAuth) {
        if (apiKey) {
          config.headers = config.headers || {};
          config.headers['X-API-KEY'] = apiKey;
        }
        return config;
      }
  
      // Добавляем API ключ
      if (apiKey) {
        config.headers = config.headers || {};
        config.headers['X-API-KEY'] = apiKey;
      }

      // Язык интерфейса — чтобы бэк отдавал локализованные данные (страны/города).
      try {
        const lng = (window.localStorage.getItem('i18nextLng') || (navigator && navigator.language) || 'en').split('-')[0];
        if (lng) {
          config.headers = config.headers || {};
          config.headers['Accept-Language'] = lng;
        }
      } catch (e) { /* noop */ }

      // Добавляем токен авторизации, если он есть
      const accessToken = window.localStorage.accessToken;
      if (accessToken) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }
      
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

// Response interceptor — 401 → обновить сессию (один refresh на всех, см.
// core/session) → повторить исходный запрос. Как callWithRefreshTokenIfNeeded
// в RN; лимит повторов, чтобы не зациклиться. Разлогин — только если сам
// refresh-токен невалиден (делает refreshSession).
const MAX_AUTH_RETRIES = 2;

axios.interceptors.response.use(
    (response) => response,
    async function (error) {
      const originalRequest = error.config;
      if (
        !originalRequest ||
        error.response?.status !== 401 ||
        originalRequest.skipAuth ||
        originalRequest.url?.includes("/auth/refreshToken")
      ) {
        return Promise.reject(error);
      }
      const tries = originalRequest._authRetries || 0;
      if (tries >= MAX_AUTH_RETRIES || !window.localStorage.refreshToken) {
        return Promise.reject(error);
      }
      originalRequest._authRetries = tries + 1;

      // Запрос ушёл со СТАРЫМ токеном, а сессию уже обновили (другой запрос/
      // вкладка) — просто повторяем с текущим, без лишнего refresh.
      const sentAuth = String(originalRequest.headers?.Authorization || originalRequest.headers?.authorization || "");
      const current = window.localStorage.accessToken;
      let token: string | null = null;
      if (current && sentAuth && sentAuth !== `Bearer ${current}` && !isRefreshInFlight()) {
        token = current;
      } else {
        token = await refreshSession("axios_interceptor");
      }
      if (!token) {
        return Promise.reject(error);
      }
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers["Authorization"] = `Bearer ${token}`;
      if (apiKey) {
        originalRequest.headers["X-API-KEY"] = apiKey;
      }
      return axios(originalRequest);
    }
  );

export default axios;
